$(function  () {

  // VARIABLES
  const menu = $('.js-menu')
  const shadow = $('.js-menu-shadow')
  const burger = $('.js-burger')
  const close = $('.js-close-burger')
  const urlApi = window.location.origin + '/blog/wp-json/wp/v2/'
  const navPage = $('.js-nav-page')
  const navOffice = $('.js-nav-office')


  // FUNCTIONS
  const openBurgerMenu = function () {
    shadow.css({ height: $(document).height() }).fadeIn()
    menu.addClass('open')
    $('body').addClass('stop-scrolling')
  }

  const closeBurgerMenu = function () {
    shadow.fadeOut()
    menu.removeClass('open')
    $('body').removeClass('stop-scrolling')
  }

  const buildMenu = function () {
    $.ajax({
      url: urlApi + 'posts?categories=2&order=asc',
      success: function (data) {
        data.forEach((office) => {
          const available = office.acf.office_available
          navOffice.append(
            $('<a>')
              .addClass(`link ${available ? '' : 'disabled'}`)
              .attr('href', available ? `${office.acf.url}` : null)
              .append(
                $('<img>')
                  .attr('src', office.acf.office_logo.url)
                  .addClass('logo')
              )
              .append(
                $('<div>')
                  .addClass('detail')
                  .append(
                    $('<div>')
                      .addClass('title')
                      .text(office.title.rendered)
                  )
                  .append(
                    $('<div>')
                      .addClass('subtitle')
                      .text(available ? '' : 'Coming soon')
                      //.text(available ? office.acf.region : 'Coming soon')
                  )
              )
          )
        })
      }
    })
    $.ajax({
      url: urlApi + 'pages?order=asc',
      success: function (data) {
        data.forEach((page) => {
          if (page.id != 150) {
            navPage.append(
              $('<a>')
                .addClass('link')
                .attr('href', page.acf ? `${page.acf.url}` : `${window.location.origin}/pages/${page.id}/${page.slug}`)
                .text(page.title.rendered)
            )
          }
        })
        navPage.append(
          $('<a>')
            .addClass('link')
            .attr('href', 'https://jointhesideoffice.typeform.com/to/Fr6UaH')
            .attr('target', '_blank')
            .text('Choisissez votre prochain office')
        )
      }
    })
  }


  // BINDINGS
  burger.on('click', openBurgerMenu)
  close.on('click', closeBurgerMenu)
  shadow.on('click', closeBurgerMenu)

  // INIT
  buildMenu()
})
